import { Loader2 } from "lucide-react";
import { forwardRef } from "react";

import { Text } from "~/components/text";
import { cn } from "~/util/cn";

type ButtonNextProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  className?: string;
};

// TODO update all other button next
export const ButtonNext = forwardRef<HTMLButtonElement, ButtonNextProps>(
  ({ disabled, loading, onClick, className = "btn-block" }, ref) => {
    return (
      <button
        ref={ref}
        type="submit"
        className={cn("btn-primary btn", className)}
        disabled={disabled}
        onClick={onClick}
      >
        {loading ? (
          <>
            <Loader2 className="animate-spin" />

            <Text tx="graph.text.loadingNextNode" />
          </>
        ) : (
          <Text tx="graph.text.next" />
        )}
      </button>
    );
  },
);

ButtonNext.displayName = "ButtonNext";
